// DrmPanelSectionRow.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Loading from './Loading.jsx';
import { RowTitle, RowContent } from '../style/SettingModal.js';

export const DrmPanelSectionRow = ({
  keySystem,
  robustness,
  drmTestResult,
  testingTestcase,
}) => {
  const isTesting = `${keySystem}:${robustness}` == testingTestcase;
  return (
    <StyledDrmPanelSectionRow>
      <RowTitle>{robustness}</RowTitle>
      <RowContent>
        {isTesting ? (
          <Loading size={20} />
        ) : drmTestResult ? (
          drmTestResult
        ) : (
          'untest'
        )}
      </RowContent>
    </StyledDrmPanelSectionRow>
  );
};

DrmPanelSectionRow.propTypes = {
  keySystem: PropTypes.string,
  robustness: PropTypes.string,
  drmTestResult: PropTypes.string,
  testingTestcase: PropTypes.string,
};

DrmPanelSectionRow.defaultProps = {
  keySystem: null,
  robustness: null,
  drmTestResult: null,
  testingTestcase: null,
};

const StyledDrmPanelSectionRow = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export default DrmPanelSectionRow;
